// Defensive mapper from an unknown server payload into a SlackStatusView.
// Returns null on malformed input so callers can treat a bad response as
// "unknown" rather than crashing the render. Extra fields are ignored.

import type { SlackStatusView } from './types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function toOptionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

export function toSlackStatusView(raw: unknown): SlackStatusView | null {
  if (!isRecord(raw)) {
    return null;
  }

  const { connected } = raw;
  if (typeof connected !== 'boolean') return null;

  const view: SlackStatusView = { connected };

  const teamId = toOptionalString(raw.teamId);
  if (teamId !== undefined) view.teamId = teamId;
  const slackUserId = toOptionalString(raw.slackUserId);
  if (slackUserId !== undefined) view.slackUserId = slackUserId;

  return view;
}
